export const mobileSize = 550,
  desktopMedia = `screen and (min-width: ${mobileSize}px)`,
  mobileMedia = `screen and (max-width: ${mobileSize - 1}px)`;
